import React from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {
	EXPORTED_FILE_NAME,
	LABEL_CONFIRMIMAGETRANSFORM,
	LABEL_SAVEASIMAGE,
} from './const';
import { postToImgur } from './imgurApi';
import { downloadURI } from './UtilsDom';

export type P_SaveButton = {
	selectedModeIndex: number;
	changeMode: (n: number) => any;
	stageToDataUrl: () => string | undefined;
};
export default function SaveButton(props: P_SaveButton) {
	if (props.selectedModeIndex === 2) {
		return (
			<Button
				variant='contained'
				onClick={() => {
					props.changeMode(3);
				}}
				color='secondary'
			>
				{LABEL_CONFIRMIMAGETRANSFORM}
			</Button>
		);
	}
	const save = () => {
		const uri = props.stageToDataUrl();
		if (!uri) {
			return;
		}
		postToImgur(uri);
		downloadURI(uri, EXPORTED_FILE_NAME);
	};

	return (
		<Button
			size='small'
			variant='contained'
			onClick={save}
			startIcon={<DownloadIcon />}
		>
			{LABEL_SAVEASIMAGE}
		</Button>
	);
}
